export const FLAGS = {
  PLACEHOLDER: 'placeholder_flag',
  MYINFO_CLIENT_ID: 'alias-myinfo-client-id',
  REFRESHED_CARD_FACES: 'alias-link-refreshed-cards',
  OCBC_CARD_REPLACEMENT: 'alias-ocbc-card-replacement',
  DATADOG: 'alias-web-datadog',
  NFC_PREFERENCES: 'nfc-preference',
  LINKPASS_TERMS_OF_USE: 'linkpass-terms-of-use',
  PROFILE_VERIFICATION_REVAMP: 'alias-profile-verification-revamp',
  NEW_MYINFO: 'alias-new-myinfo',
  PERSONA_API_MIGRATION: 'dynamics_persona-api-migration',
  DISABLE_LP_RESTORATION: 'alias-disable-restoration-flow',
  GRANULAR_PREFERENCE_MANAGEMENT: 'dynamics_granunlar_preference_page',
  DISABLE_CONTINUE_AND_DONE_BUTTON: 'dynamics_disable_continue_done_button_fix',
  CORE_PRODUCT_MYINFO_UPDATE: 'core-product-myinfo-flow-update',
};

export const FLAG_ATTRIBUTES = {
  platform: 'web',
};

export const FLAGS_VALUES = Object.keys(FLAGS).map((k) => FLAGS[k]);
